import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

function StockList (props) {
  const { list, fetch, fetching, onShow, company, onChangeCompany } = props
  console.log({ list })

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Company', accessor: 'company.fn', hideable: true, hideDefault: true },
    { Header: 'Name', accessor: 'name' },
    {
      Header: 'unit',
      accessor: 'unit',
      Cell: ({ original, value }) => value * (original.type === 'credit' ? 1 : -1),
    },
    { Header: 'onOrder', accessor: 'onOrder' },
    { Header: 'onSell', accessor: 'onSell' },
    { Header: 'Total Units', accessor: 'totalUnit' },
    { Header: 'Type', accessor: 'type' },
    { Header: 'UOM', accessor: 'uom.code' },
    { Header: 'Purchases', accessor: 'purchases.code' },
    { Header: 'Purchases Line ID', accessor: 'purchasesLines.name', hideable: true, hideDefault: true },
    { Header: 'Purchases Line', accessor: 'purchasesLines.name' },
    { Header: 'Product ID', accessor: 'product._id', hideable: true, hideDefault: true },
    { Header: 'Product', accessor: 'product.name', hideable: true, hideDefault: true },
    { Header: 'SKU ID', accessor: 'productLine._id' },
    { Header: 'SKU', accessor: 'productLine.name' },
    { Header: 'Category', accessor: 'category.name' },
    { Header: 'Group', accessor: 'group.name' },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      defaultSorted={[
        {
          id: '_key',
          desc: false,
        },
      ]}
    />
  )
}

StockList.propTypes = {}
StockList.defaultProps = {}

export default StockList
